
export enum AttackType {
    Melee,
    Ranged
}